import './index.scss';

import { Component } from 'react';
import { BraxButton, BraxIcon, BraxModals, BraxModalsType, BraxToasts, BraxToastsType } from 'design-system';

import t from '../../utils/i18n';
import handleError from '../../utils/errors';
import { withContexts } from '../../utils/with-context';
import User from '../../view-model/users/User';
import paymentsService from '../../services/payments';
import UserContext from '../../contexts/User';
import PaymentConfirmation from '../PaymentConfirmation';
import ExternalLink from '../ExternalLink';

export type TopBarNoticesProps = {
    modals: BraxModalsType,
    toasts: BraxToastsType,
    user: User
};

type TopBarNoticesState = {
    checking: boolean,
    checked: boolean
};

export default withContexts({
    modals: BraxModals,
    toasts: BraxToasts,
    user: UserContext
}, class TopBarNotices extends Component<TopBarNoticesProps, TopBarNoticesState> {

    state = {
        checking: false,
        checked: false
    };

    async checkPayment() {
        this.setState({ checking: true });

        try {
            const response = await paymentsService.checkPayment(this.props.user.id, this.props.user.invoicePending!.id);

            if (response.result.confirmed)
                this.setState({ checked: true });

            this.props.modals.custom(<PaymentConfirmation {...response.result} />);
        } catch (error) {
            this.props.toasts.create({ type: 'destructive', ...handleError(error) });
        }

        this.setState({ checking: false });
    }

    render() {
        return (
            <div className="top-bar-notices">
                { !this.state.checked && this.props.user.isDefaulter && this.props.user.invoicePending ? (
                    <div>
                        <BraxIcon icon="exclamation-mark-triangle" variant="secondary" />

                        <div className="content">
                            <h3>{ t('Você possui uma fatura em aberto') }</h3>

                            <p>{ t('Sua assinatura venceu e nosso sistema não conseguiu realizar a cobrança automática. Seus projetos foram inativados, mas voltarão a ficar ativos assim que o pagamento for identificado. Para acessar a fatura e regularizar a pendência, clique no botão ”Pagar Fatura”. Caso já tenha realizado o pagamento, clique em ”Verificar Pagamento”.') }</p>
                        </div>

                        <div className="actions">
                            <ExternalLink href={this.props.user.invoicePending.url}>
                                <BraxButton variant="primary" size="md">{ t('Pagar fatura') }</BraxButton>
                            </ExternalLink>

                            <BraxButton variant="secondary" size="md" onClick={() => this.checkPayment()}>
                                { t(this.state.checking ? 'Verificando...' : 'Verificar pagamento') }
                            </BraxButton>
                        </div>
                    </div>
                ) : null }
            </div>
        );
    }

});
